import * as React from 'react';
import { WalkthroughContext } from 'features/feed/components/walkthrough/context';
import AccountChartView from './AccountChartView';
import AccountChartInfoView from './AccountChartInfoView';
import { ChartType } from '../types';
const AccountsChart = ({ title, pieData, chartType, requesting, setChartType, selectedPeriod, selectedInfoObj, selectedInfoObj2, portfolioDataSet, portfolioDataSet2, setSelectedPeriod, }) => {
    const isInWalkthrough = React.useContext(WalkthroughContext);
    return (<>
      <AccountChartInfoView title={title} selectedInfoObj={selectedInfoObj} isAssetVsDebt={chartType === ChartType.assetVsDebt} lastItem={portfolioDataSet[selectedPeriod]?.lastItem}/>
      {!isInWalkthrough && (<AccountChartView title={title} pieData={pieData} chartType={chartType} requesting={requesting} setChartType={setChartType} selectedPeriod={selectedPeriod} selectedInfoObj={selectedInfoObj} selectedInfoObj2={selectedInfoObj2} portfolioDataSet={portfolioDataSet} portfolioDataSet2={portfolioDataSet2} setSelectedPeriod={setSelectedPeriod}/>)}
    </>);
};
export default AccountsChart;
